module.exports = __webpack_public_path__ + "static/media/arrow-left.d51ab971.svg";